import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-721439f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';
import Breadcrumbs from '@/components/Breadcrumbs.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isLoading = ref(true);
const store = useStore();
const breadcrumbs = [
  {
    label: 'ホーム',
    name: 'f00',
  },
  {
    label: '利用規約の同意',
  },
];

onBeforeMount(async () => {
  isLoading.value = true;
  try {
    await store.dispatch('provision/receive');
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(Breadcrumbs, { breadcrumbs: breadcrumbs }),
        _createVNode(_component_router_view)
      ]))
    : _createCommentVNode("", true)
}
}

})